import { render } from "./ArchiveSendouts.vue?vue&type=template&id=7e800d72"
import script from "./ArchiveSendouts.vue?vue&type=script&lang=js"
export * from "./ArchiveSendouts.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/sendOuts/ArchiveSendouts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e800d72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e800d72', __exports__)) {
    console.log('reload')
    api.reload('7e800d72', __exports__)
  }
  
  module.hot.accept("./ArchiveSendouts.vue?vue&type=template&id=7e800d72", () => {
    console.log('re-render')
    api.rerender('7e800d72', render)
  })

}


export default __exports__